import React, { useEffect, useRef, useState } from 'react';
import { IsB2bAgent } from '../../../../../utils/isB2bAgent';
import FlagIcon from '../../../Icons/FlagIcon';
import CheckmarkIcon from '../../../Icons/CheckMarkIcon';
import 'amazon-connect-streams';
import { countrySelectorUtil } from '../../../../../utils/countrySelectorUtil';
import { countryCodes, Country } from '../../../../../models/Country';
import { Button, Menu, MenuItem, ListItem, Typography, Box } from '@coolblue-development/freddy';

interface CountrySelectorProps {
  onCountrySelect: (country: Country) => void;
}

const CountrySelector: React.FC<CountrySelectorProps> = ({ onCountrySelect }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<Country | null>(null);

  const handleClick = (): void => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleMenuItemClick = (country: Country): void => {
    setSelectedCountry(country);
    onCountrySelect(country);
    handleClose();
  };

  useEffect(() => {
    const defaultCountry = countrySelectorUtil(countryCodes);
    setSelectedCountry(defaultCountry);
  }, []);

  const filteredPhoneCountryCodes = IsB2bAgent() ? countryCodes : countryCodes.filter(country => !country.isB2b);

  return (
    <>
      <Button
        ref={buttonRef}
        sx={{
          background: 'none',
          boxShadow: 'none',
          fontSize: '',
          alignSelf: 'center',
          height: '45px',
          padding: '7px',
          ':hover': { background: '#33373F', boxShadow: 'none' }
        }}
        data-testid="country-selector-button"
        size="medium"
        onClick={handleClick}
        startIcon={selectedCountry ? <FlagIcon Component={selectedCountry.icon} /> : null}
      >
        {selectedCountry?.code}
      </Button>
      <Menu
        sx={{
          position: 'relative',
          zIndex: 20,
          '& > div': { background: '#33373F', overflowY: 'auto' },
          '& [role="menuitem"]': { color: '#fff' }
        }}
        referenceElement={buttonRef.current}
        open={open}
        onClose={handleClose}
        maxHeight="300px"
      >
        {filteredPhoneCountryCodes.map(country => (
          <MenuItem key={country.code} onClick={() => handleMenuItemClick(country)}>
            <ListItem sx={{ display: 'flex', alignItems: 'center', gap: '8px', listStyle: 'none' }}>
              <FlagIcon Component={country.icon} />
              <Typography sx={{ '&&&': { marginBottom: '0px' } }}>{country.code}</Typography>

              {selectedCountry?.code === country.code && (
                <Box sx={{ svg: { maxWidth: '10px', marginLeft: 'auto' } }}>
                  <CheckmarkIcon />
                </Box>
              )}
            </ListItem>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default CountrySelector;
